module.exports = __webpack_public_path__ + "static/media/BarlowCondensed-LightItalic.fc6c7379.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowCondensed-LightItalic.ttf
// module id = 2997
// module chunks = 71